/**
 * Designation strings vary ("MIS Incharge", "In-Charge MIS", "In Charge MIS").
 * Shared by login session role, change-of-vendor filters, and dashboard routing.
 */
export function designationIsIncharge(designation: string | undefined): boolean {
    if (!designation?.trim()) return false;
    const norm = designation.trim().normalize('NFC').replace(/_/g, ' ').toLowerCase();
    if (norm.includes('incharge') || norm.includes('inchage')) return true;
    return /\bin[\s-]+charge\b/i.test(norm);
}

/**
 * MIS oversight incharge. Handles DB variants: `Incharge_MIS`, `MIS Incharge`, `InchargeMIS`
 * (underscore / space / camel), and trims Unicode oddities.
 */
export function designationIsMisIncharge(designation: string | undefined): boolean {
    if (!designationIsIncharge(designation) || !designation?.trim()) return false;
    const raw = designation.trim().normalize('NFC');
    const spaced = raw.replace(/_/g, ' ');
    if (/\bmis\b/i.test(spaced)) return true;
    const letters = raw.toLowerCase().replace(/[^a-z]/g, '');
    if (letters.includes('misincharge') || letters.includes('inchargemis')) return true;
    return false;
}

/** Normalize change-of-vendor status from Firestore for comparisons. */
export function normalizeChangeOfVendorStatus(
    status: string | undefined | null
): 'pending' | 'approved' | 'rejected' | 'cancelled' | 'forwarded_to_head' {
    const s = (status ?? 'Pending').trim().toLowerCase();
    if (s === 'approved') return 'approved';
    if (s === 'rejected') return 'rejected';
    if (s === 'cancelled' || s === 'canceled') return 'cancelled';
    if (s === 'forwarded to head' || s === 'forwarded_to_head') return 'forwarded_to_head';
    return 'pending';
}
